/*!
 * Copyright Optimus Ride 2020
 */

import { Address, LatLon } from '@optimusride/client-library/grpc/shared_pb';
import { Station as GrpcStation } from '@optimusride/client-library/grpc/station_pb';

export interface Station {
    id: number;
    latLon?: LatLon;
    nickname: string;
    disabled: boolean;
    disabledDate: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalcode?: string;
    country?: string;
    linksToList?: number[];
    linksFromList?: number[];
}

export function toStation(station: GrpcStation): Station {
    return {
        id: station.getId(),
        latLon: station.getLatLon(),
        nickname: station.getNickname(),
        address1: station.getAddress()?.getAddress1(),
        address2: station.getAddress()?.getAddress2(),
        city: station.getAddress()?.getCity(),
        state: station.getAddress()?.getStateProvince(),
        postalcode: station.getAddress()?.getPostalCode(),
        country: station.getAddress()?.getCountry(),
        disabled: station.getDisabledDate() !== "",
        disabledDate: station.getDisabledDate(),
    }
}

export function toGRPCStation(station: Station): GrpcStation {
    const grpcStation = new GrpcStation();
    const latLon = new LatLon();
    const address = new Address();
    
    grpcStation.setId(station.id);

    if (station.latLon) {
        latLon.setLatitude(station.latLon?.getLatitude());
        latLon.setLongitude(station.latLon?.getLongitude());
        grpcStation.setLatLon(latLon);
    }

    grpcStation.setLinksFromList(station.linksFromList && station.linksFromList?.length > 0 
        ? station.linksFromList 
        : [-1]);
    grpcStation.setLinksToList(station.linksToList && station.linksToList.length > 0 
        ? station.linksToList 
        : [-1]);

    grpcStation.setNickname(station.nickname);

    address.setAddress1(station.address1 || "");
    address.setAddress2(station.address2 || "");
    address.setCity(station.city || "");
    address.setCountry(station.country || "");
    address.setPostalCode(station.postalcode || "");
    // address.setCountry();

    grpcStation.setAddress(address);

    return grpcStation;
}

export function isStation(thingToCheck: any): thingToCheck is Station {
    return (
        thingToCheck &&
        (thingToCheck as Station).id !== undefined &&
        (thingToCheck as Station).nickname !== undefined &&
        (thingToCheck as Station).disabled !== undefined
    );
}
